
const AddIcon = ({ color, scale }: { color?: string; scale?: number }) => {
  return (
    <svg
      width="20"
      style={{ transform: `scale(${scale || 1})` }}
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icons/Base">
        <g id="Group">
          <path
            id="Vector"
            d="M10.5 17.921C8.39924 17.921 6.38453 17.0865 4.89907 15.601C3.41362 14.1156 2.57909 12.1008 2.57909 10.0001C2.57909 7.89933 3.41362 5.88462 4.89907 4.39916C6.38453 2.91371 8.39924 2.07919 10.5 2.07919C12.6007 2.07919 14.6155 2.91371 16.1009 4.39916C17.5864 5.88462 18.4209 7.89933 18.4209 10.0001C18.4209 12.1008 17.5864 14.1156 16.1009 15.601C14.6155 17.0865 12.6007 17.921 10.5 17.921ZM10.5 19.2668C12.9577 19.2668 15.3147 18.2905 17.0526 16.5527C18.7904 14.8148 19.7667 12.4578 19.7667 10.0001C19.7667 7.54239 18.7904 5.18536 17.0526 3.44751C15.3147 1.70966 12.9577 0.733344 10.5 0.733344C8.0423 0.733344 5.68527 1.70966 3.94742 3.44751C2.20957 5.18536 1.23325 7.54239 1.23325 10.0001C1.23325 12.4578 2.20957 14.8148 3.94742 16.5527C5.68527 18.2905 8.0423 19.2668 10.5 19.2668Z"
            fill={color || "#E3E4E5"}
            stroke={color || "#E3E4E5"}
            strokeWidth="0.2"
          />
          <path
            id="Vector_2"
            d="M10.9759 5.51378C10.8497 5.38758 10.6786 5.31669 10.5001 5.31669C10.3216 5.31669 10.1505 5.38758 10.0243 5.51378C9.89809 5.63998 9.8272 5.81114 9.8272 5.98961V9.32714H6.48967C6.3112 9.32714 6.14004 9.39803 6.01384 9.52423C5.88765 9.65043 5.81675 9.82159 5.81675 10.0001C5.81675 10.1785 5.88765 10.3497 6.01384 10.4759C6.14004 10.6021 6.3112 10.673 6.48967 10.673H9.8272V14.0105C9.8272 14.189 9.89809 14.3601 10.0243 14.4863C10.1505 14.6125 10.3216 14.6834 10.5001 14.6834C10.6786 14.6834 10.8497 14.6125 10.9759 14.4863C11.1021 14.3601 11.173 14.189 11.173 14.0105V10.673H14.5106C14.689 10.673 14.8602 10.6021 14.9864 10.4759C15.1126 10.3497 15.1835 10.1785 15.1835 10.0001C15.1835 9.82159 15.1126 9.65043 14.9864 9.52423C14.8602 9.39803 14.689 9.32714 14.5106 9.32714H11.173V5.98961C11.173 5.81114 11.1021 5.63998 10.9759 5.51378Z"
            fill={color || "#E3E4E5"}
            stroke={color || "#E3E4E5"}
            strokeWidth="0.2"
          />
        </g>
      </g>
    </svg>
  );
};

export default AddIcon;
